import React from 'react';
import '../../sass/main.scss';

const Hamburger = () => {
    return <div className="Hamburger">
               <div className="Hamburger-item"></div>
           </div>
}

export default Hamburger